export default __webpack_public_path__ + "static/media/the_smog.4b8c1cba.png";